export const adjustCustomerByIdData = customer => {
  let newData = {};
  if (customer.address_fact) {
    newData["addressFact"] = customer.address_fact;
  }
  if (customer.address_legal) {
    newData["addressLegal"] = customer.address_legal;
  }
  if (customer.archive) {
    newData["archive"] = customer.archive;
  }
  if (customer.bank_account) {
    newData["bankAccount"] = customer.bank_account.map((item, index) => index);
    customer.bank_account.forEach((item, index) => {
      newData["accountCorr" + index] = item.account_corr;
      newData["bankName" + index] = item.bank_name;
      newData["bik" + index] = item.bik;
      newData["bankAccountNum" + index] = item.bank_account_num;
      newData["bankAccountId" + index] = item.bank_account_id;
    });
  }
  if (customer.birth_date) {
    newData["birthDate"] = customer.birth_date;
  }
  if (customer.birth_place) {
    newData["birthPlace"] = customer.birth_place;
  }
  if (customer.cashier_account_id) {
    newData["cashierAccountId"] = customer.cashier_account_id;
  }
  if (customer.company_id) {
    newData["companyId"] = customer.company_id;
  }
  if (customer.profile_id) {
    newData["profileId"] = customer.profile_id;
  }
  if (customer.company_licensee_type_id) {
    newData["companyLicenseeTypeId"] = customer.company_licensee_type_id;
  }
  if (customer.company_type_id) {
    newData["companyTypeId"] = customer.company_type_id;
  }
  if (customer.created_at) {
    newData["createdAT"] = customer.created_at;
  }
  if (customer.deleted_at) {
    newData["deletedAt"] = customer.deleted_at;
  }
  if (customer.eio) {
    newData["eio"] = customer.eio;
  }
  if (customer.email) {
    newData["email"] = customer.email;
  }
  if (customer.inn) {
    newData["inn"] = customer.inn;
  }
  if (customer.kpp) {
    newData["kpp"] = customer.kpp;
  }
  if (customer.lastname) {
    newData["lastname"] = customer.lastname;
  }
  if (customer.license_number) {
    newData["licenseNumber"] = customer.license_number;
  }
  if (customer.name) {
    newData["name"] = customer.name;
  }
  if (customer.name_legal) {
    newData["nameLegal"] = customer.name_legal;
  }
  if (customer.nds) {
    newData["nds"] = customer.nds;
  }
  if (customer.ogrn) {
    newData["ogrn"] = customer.ogrn;
  }
  if (customer.ogrnip) {
    newData["ogrn"] = customer.ogrnip;
  }
  if (customer.passport_authority) {
    newData["passportAuthority"] = customer.passport_authority;
  }
  if (customer.passport_data) {
    newData["passportData"] = customer.passport_data;
  }
  if (customer.passport_number) {
    newData["passportNumber"] = customer.passport_number;
  }
  if (customer.passport_series) {
    newData["passportSeries"] = customer.passport_series;
  }
  if (customer.patronymic) {
    newData["patronymic"] = customer.patronymic;
  }
  if (customer.phone) {
    newData["phone"] = customer.phone;
  }
  if (customer.phone_code) {
    newData["phoneCode"] = customer.phone_code;
  }
  if (customer.registraton_date) {
    newData["registrationDate"] = customer.registraton_date
  }
  if (customer.site) {
    newData["site"] = customer.site;
  }
  if (customer.status) {
    newData["status"] = customer.status;
  }
  if (customer.subject_id) {
    newData["subjectId"] = customer.subject_id;
    if (customer.subject_id === 4) {
      newData["subject"] = "Юридическое лицо";
      newData["subjectKey"] = "legal";
    }
    if (customer.subject_id === 5) {
      newData["subject"] = "Физическое лицо";
      newData["subjectKey"] = "physical";
    }
    if (customer.subject_id === 6) {
      newData["subject"] = "Индивидуальный предприниматель";
      newData["subjectKey"] = "individ";
    }
  }
  if (customer.tariff_end_date) {
    newData["tariffEndDate"] = customer.tariff_end_date;
  }
  if (customer.tariff_fee_period_id) {
    newData["tariffFeePeriodId"] = customer.tariff_fee_period_id;
  }
  if (customer.tariff_purchase_date) {
    newData["purchaseDate"] = customer.tariff_purchase_date;
  }
  if (customer.tariff_type_id) {
    newData["tariffTypeId"] = customer.tariff_type_id;
  }
  if (customer.teleportos_account_id) {
    newData["teleportosAccountId"] = customer.teleportos_account_id;
  }
  if (customer.trial_period) {
    newData["trialPeriod"] = customer.trial_period;
  }
  if (customer.updated_at) {
    newData["updatedAt"] = customer.updated_at;
  }

  return newData;
};
